import { NextPage } from 'next';
import { FC, Fragment } from 'react';
import { Element, Link as ScrollLink } from 'react-scroll';
// -------- custom component -------- //
import { Navbar } from 'components/blocks/navbar';
import { Footer1 } from 'components/blocks/footer';
import Breadcrumb from 'components/reuseable/Breadcrumb';
import PageProgress from 'components/common/PageProgress';
import NextLink from 'components/reuseable/links/NextLink';
// -------- data -------- //
import * as All from 'data/keywords';
import SEO from 'components/common/SEO';
import Link from 'next/link'; 
const linkList = [
  { id: 1, title: '1. Introduction', to: 'introduction' },
  { id: 2, title: '2. Privacy Policy', to: 'privacy-policy' },
  { id: 3, title: '3. Fees and Payment', to: 'fees' },
  { id: 4, title: '4. Client Responsibilities', to: 'client' },
  { id: 5, title: '5. Confidentiality', to: 'confidentiality' },
  { id: 6, title: '6. Intellectual Property', to: 'intellectual' },
  { id: 7, title: '7. Termination', to: 'termination' },
  { id: 8, title: '8. Limitation of Liability', to: 'limitation' },
  { id: 9, title: '9. Governing Law', to: 'governing' },
  { id: 1, title: '10. Entire Agreement', to: 'agreement' }
];
const breadcrumb = [
  { id: 1, title: 'Home', url: '/' },
  { id: 2, title: 'Terms and Conditions', url: '/terms' }
];
const details = {
  pageName: 'Terms and Conditions',
  categories: 'Terms and Conditions',
  description: 'Molto SEO terms and conditions.',
  parentDirectories: ''
};
const Terms: NextPage = () => {
  return (
    <>
      <SEO
        title={details.pageName}
        description={details.description}
        tag={details.categories}
        url={`/terms}`}
        image={`https://moltoseo.co.uk/img/logo/technical-seo-agency.png`}
        // updated=""
        // published=""
        // modified=""
      />

      <Fragment>
        {/* <PageProgress /> */}

        {/* ========== header section ========== */}
        

        <main className="content-wrapper">
          <section className="wrapper bg-soft-primary">
            <div className="container pt-10 pb-12 pt-md-14 pb-md-16 text-center">
              <div className="row">
                <div className="col-md-10 col-lg-8 col-xl-7 col-xxl-6 mx-auto">
                  <h1 className="display-1 mb-3">Terms and Conditions</h1>
                  <Breadcrumb data={breadcrumb} />
                </div>
              </div>
            </div>
          </section>

          <div className="container">
            <div className="row gx-0">
              <aside className="col-xl-3 sidebar sticky-sidebar mt-md-0 py-16 d-none d-xl-block">
                <div className="widget">
                  <nav id="sidebar-nav">
                    <ul className="list-unstyled text-reset">
                      {linkList.map(({ id, title, to }) => (
                        <li key={id}>
                          <ScrollLink smooth spy activeClass="active" to={to} className="nav-link">
                            {title}
                          </ScrollLink>
                        </li>
                      ))}
                    </ul>
                  </nav>
                </div>
              </aside>

              <div className="col-xl-8">
                <Element name="introduction" className="wrapper pt-16">
                  <div className="card">
                    <div className="card-body p-10">
                      <h2 className="mb-3">1. Introduction</h2>
                      <p>
                        Welcome to{' '}
                        <a href="https://moltoseo.co.uk/" title="MoltoTechnical SEO agency">
                          Molto SEO
                        </a>
                        , a digital marketing agency that provides SEO, social media marketing, web design, and PPC
                        services. By using our services, you agree to be bound by the following terms and conditions:
                      </p>
                      {/* 
                    <List
                      data={[
                        'Aenean eu leo quam ornare curabitur blandit tempus.',
                        'Nullam quis risus eget urna mollis ornare donec elit.',
                        'Etiam porta sem malesuada magna mollis euismod.',
                        'Fermentum massa vivamus faucibus amet euismod.'
                      ]}
                    /> */}
                    </div>
                  </div>
                </Element>

                <Element name="privacy-policy" className="wrapper pt-16">
                  <div className="card">
                    <div className="card-body p-10">
                      <h2 className="mb-3">2. Privacy Policy</h2>
                      <p>
                        Scope of Services Molto SEO provides SEO, social media marketing, web design, and
                        PPC services to its clients. The services are delivered in accordance with the package selected
                        by the client. Molto SEO reserves the right to change the services or discontinue
                        them at any time without prior notice.
                      </p>

                      {/* <List
                      data={[
                        'Aenean eu leo quam ornare curabitur blandit tempus.',
                        'Nullam quis risus eget urna mollis ornare donec elit.',
                        'Etiam porta sem malesuada magna mollis euismod.',
                        'Fermentum massa vivamus faucibus amet euismod.'
                      ]}
                    /> */}
                    </div>
                  </div>
                </Element>
                <Element name="fees" className="wrapper pt-16">
                  <div className="card">
                    <div className="card-body p-10">
                      <h2 className="mb-3">Fees and Payment</h2>
                      <p>
                        The fees for Molto SEO's services are specified in the package selected by the
                        client. Payment is due in full before the start of the project. Molto SEO{' '}
                        reserves the right to suspend or terminate its services if payment is not received on time.
                      </p>
                    </div>
                  </div>
                </Element>
                <Element name="client" className="wrapper pt-16">
                  <div className="card">
                    <div className="card-body p-10">
                      <h2 className="mb-3">Client Responsibilities</h2>
                      <p>
                        The client is responsible for providing accurate and complete information necessary for molto{' '}
                        SEO to deliver its services. The client also agrees to promptly review and
                        approve all materials and deliverables provided by Molto SEO.
                      </p>
                    </div>
                  </div>
                </Element>
                <Element name="confidentiality" className="wrapper pt-16">
                  <div className="card">
                    <div className="card-body p-10">
                      <h2 className="mb-3">Confidentiality</h2>
                      <p>
                        Molto SEO agrees to keep all client information confidential and not disclose it
                        to any third party without the client's consent. The client agrees to keep confidential all
                        Molto SEO's proprietary information, including trade secrets, and not disclose it
                        to any third party without Molto SEO's consent.
                      </p>
                    </div>
                  </div>
                </Element>
                <Element name="intellectual" className="wrapper pt-16">
                  <div className="card">
                    <div className="card-body p-10">
                      <h2 className="mb-3">Intellectual Property</h2>
                      <p>
                        Molto SEO retains all rights to any intellectual property developed by molto{' '}
                        SEO in connection with the services provided to the client. The client agrees not
                        to use, reproduce, distribute, or sell any intellectual property developed by molto{' '}
                        SEO without Molto SEO's consent.
                      </p>
                    </div>
                  </div>
                </Element>
                <Element name="termination" className="wrapper pt-16">
                  <div className="card">
                    <div className="card-body p-10">
                      <h2 className="mb-3">Termination</h2>
                      <p>
                        Either party may terminate the agreement at any time for any reason upon written notice to the
                        other party. Upon termination, the client agrees to pay all fees due to Molto SEO{' '}
                        for services rendered up to the date of termination.
                      </p>
                    </div>
                  </div>
                </Element>
                <Element name="limitation" className="wrapper pt-16">
                  <div className="card">
                    <div className="card-body p-10">
                      <h2 className="mb-3">Limitation of Liability</h2>
                      <p>
                        Molto SEO shall not be liable for any direct, indirect, special, incidental, or
                        consequential damages arising out of or in connection with the services provided to the client,
                        including but not limited to damages for lost profits, loss of data, or interruption of
                        business, even if Molto SEO has been advised of the possibility of such damages.
                      </p>
                    </div>
                  </div>
                </Element>
                <Element name="governing" className="wrapper pt-16">
                  <div className="card">
                    <div className="card-body p-10">
                      <h2 className="mb-3">Governing Law</h2>
                      <p>
                        This agreement shall be governed by and construed in accordance with the laws of England and
                        Wales. Any disputes arising out of or in connection with this agreement shall be resolved by the
                        courts of England and Wales.
                      </p>
                    </div>
                  </div>
                </Element>
                <Element name="agreement" className="wrapper pt-16">
                  <div className="card">
                    <div className="card-body p-10">
                      <h2 className="mb-3">Entire Agreement</h2>
                      <p>
                        This agreement constitutes the entire agreement between Molto SEO and the client
                        and supersedes all prior agreements and understandings, whether written or oral, relating to the
                        subject matter of this agreement. By using Molto SEO's services, you acknowledge
                        that you have read, understood, and agree to be bound by these terms and conditions.
                      </p>
                    </div>
                  </div>
                </Element>
                <p>&nbsp;</p>
                <p>&nbsp;</p>
                <p>&nbsp;</p>
                {/* <Element name="user-policy" className="wrapper pt-16">
                <div className="card">
                  <div className="card-body p-10">
                    <h2 className="mb-3">3. User Policy</h2>
                    <p>
                      Donec id elit non mi porta gravida at eget metus. Praesent commodo cursus magna, vel scelerisque
                      nisl consectetur et. Cras mattis consectetur purus sit amet fermentum. Lorem ipsum dolor sit amet,
                      consectetur adipiscing elit. Nulla vitae elit libero, a pharetra augue. Nullam quis risus eget
                      urna mollis ornare vel eu leo. Cras justo odio, dapibus ac facilisis in, egestas eget quam.
                    </p>
                    <p>
                      Sed posuere consectetur est at lobortis. Maecenas faucibus mollis interdum. Cum sociis natoque
                      penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec id elit non mi porta
                      gravida at eget metus. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Cum sociis
                      natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.
                    </p>
                    <p className="mb-0">
                      Nullam quis risus eget urna mollis ornare vel eu leo. Maecenas sed diam eget risus varius blandit
                      sit amet non magna. Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Nullam id
                      dolor id nibh ultricies vehicula ut id elit. Donec ullamcorper nulla non metus auctor fringilla.
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam porta sem malesuada magna mollis
                      euismod. Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Nulla vitae elit
                      libero, a pharetra augue. Curabitur blandit tempus porttitor. Cras justo odio, dapibus ac
                      facilisis in, egestas eget quam. Fusce dapibus, tellus ac cursus commodo, tortor mauris
                      condimentum nibh, ut fermentum massa justo sit amet risus. Aenean eu leo quam. Pellentesque ornare
                      sem.
                    </p>
                  </div>
                </div>
              </Element>

              <Element name="copyrights" className="wrapper pt-16">
                <div className="card">
                  <div className="card-body p-10">
                    <h2 className="mb-3">4. Copyrights</h2>
                    <p>
                      Donec id elit non mi porta gravida at eget metus. Praesent commodo cursus magna, vel scelerisque
                      nisl consectetur et. Cras mattis consectetur purus sit amet fermentum. Lorem ipsum dolor sit amet,
                      consectetur adipiscing elit. Nulla vitae elit libero, a pharetra augue. Nullam quis risus eget
                      urna mollis ornare vel eu leo. Cras justo odio, dapibus ac facilisis in, egestas eget quam.
                    </p>
                    <p>
                      Sed posuere consectetur est at lobortis. Maecenas faucibus mollis interdum. Cum sociis natoque
                      penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec id elit non mi porta
                      gravida at eget metus. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Cum sociis
                      natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.
                    </p>

                    <List
                      data={[
                        'Aenean eu leo quam ornare curabitur blandit tempus.',
                        'Nullam quis risus eget urna mollis ornare donec elit.',
                        'Etiam porta sem malesuada magna mollis euismod.',
                        'Fermentum massa vivamus faucibus amet euismod.'
                      ]}
                    />

                    <p className="mb-0 mt-5">
                      Nullam quis risus eget urna mollis ornare vel eu leo. Maecenas sed diam eget risus varius blandit
                      sit amet non magna. Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Nullam id
                      dolor id nibh ultricies vehicula ut id elit. Donec ullamcorper nulla non metus auctor fringilla.
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam porta sem malesuada magna mollis
                      euismod. Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Nulla vitae elit
                      libero, a pharetra augue. Curabitur blandit tempus porttitor. Cras justo odio, dapibus ac
                      facilisis in, egestas eget quam. Fusce dapibus, tellus ac cursus commodo, tortor mauris
                      condimentum nibh, ut fermentum massa justo sit amet risus. Aenean eu leo quam. Pellentesque ornare
                      sem.
                    </p>
                  </div>
                </div>
              </Element>

              <Element name="cookies" className="wrapper pt-16">
                <div className="card">
                  <div className="card-body p-10">
                    <h2 className="mb-3">5. Cookies</h2>
                    <p>
                      Donec id elit non mi porta gravida at eget metus. Praesent commodo cursus magna, vel scelerisque
                      nisl consectetur et. Cras mattis consectetur purus sit amet fermentum. Lorem ipsum dolor sit amet,
                      consectetur adipiscing elit. Nulla vitae elit libero, a pharetra augue. Nullam quis risus eget
                      urna mollis ornare vel eu leo. Cras justo odio, dapibus ac facilisis in, egestas eget quam.
                    </p>
                    <p>
                      Sed posuere consectetur est at lobortis. Maecenas faucibus mollis interdum. Cum sociis natoque
                      penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec id elit non mi porta
                      gravida at eget metus. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Cum sociis
                      natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.
                    </p>
                    <p className="mb-0">
                      Nullam quis risus eget urna mollis ornare vel eu leo. Maecenas sed diam eget risus varius blandit
                      sit amet non magna. Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Nullam id
                      dolor id nibh ultricies vehicula ut id elit. Donec ullamcorper nulla non metus auctor fringilla.
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam porta sem malesuada magna mollis
                      euismod. Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Nulla vitae elit
                      libero, a pharetra augue. Curabitur blandit tempus porttitor. Cras justo odio, dapibus ac
                      facilisis in, egestas eget quam. Fusce dapibus, tellus ac cursus commodo, tortor mauris
                      condimentum nibh, ut fermentum massa justo sit amet risus. Aenean eu leo quam. Pellentesque ornare
                      sem.
                    </p>
                  </div>
                </div>
              </Element>

              <Element name="account-billing" className="wrapper py-16">
                <div className="card">
                  <div className="card-body p-10">
                    <h2 className="mb-3">6. Account &amp; Billing</h2>
                    <p>
                      Donec id elit non mi porta gravida at eget metus. Praesent commodo cursus magna, vel scelerisque
                      nisl consectetur et. Cras mattis consectetur purus sit amet fermentum. Lorem ipsum dolor sit amet,
                      consectetur adipiscing elit. Nulla vitae elit libero, a pharetra augue. Nullam quis risus eget
                      urna mollis ornare vel eu leo. Cras justo odio, dapibus ac facilisis in, egestas eget quam.
                    </p>
                    <p>
                      Sed posuere consectetur est at lobortis. Maecenas faucibus mollis interdum. Cum sociis natoque
                      penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec id elit non mi porta
                      gravida at eget metus. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Cum sociis
                      natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.
                    </p>
                    <p className="mb-0">
                      Nullam quis risus eget urna mollis ornare vel eu leo. Maecenas sed diam eget risus varius blandit
                      sit amet non magna. Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Nullam id
                      dolor id nibh ultricies vehicula ut id elit. Donec ullamcorper nulla non metus auctor fringilla.
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam porta sem malesuada magna mollis
                      euismod. Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Nulla vitae elit
                      libero, a pharetra augue. Curabitur blandit tempus porttitor. Cras justo odio, dapibus ac
                      facilisis in, egestas eget quam. Fusce dapibus, tellus ac cursus commodo, tortor mauris
                      condimentum nibh, ut fermentum massa justo sit amet risus. Aenean eu leo quam. Pellentesque ornare
                      sem.
                    </p>
                  </div>
                </div>
              </Element> */}
              </div>
            </div>
          </div>
        </main>

        {/* ========== footer section ========== */}
        <Footer1
          address={[
            <>
              {All.SiteIdentity[0].address1},<br></br> {All.SiteIdentity[0].address2},<br></br>{' '}
              {All.SiteIdentity[0].address3}
            </>
          ]}
          email={All.SiteIdentity[0].email}
          phone={All.SiteIdentity[0].phone}
          
        />
      </Fragment>
    </>
  );
};

const List: FC<{ data: string[] }> = ({ data }) => {
  return (
    <ul className="icon-list bullet-bg bullet-soft-primary mb-0">
      {data.map((item) => {
        return (
          <li key={item}>
            <span>
              <i className="uil uil-check" />
            </span>
            <span>{item}</span>
          </li>
        );
      })}
    </ul>
  );
};

export default Terms;
